import { render, staticRenderFns } from "./GeneralSettingContactAddressStreet.vue?vue&type=template&id=18f2a8be&"
import script from "./GeneralSettingContactAddressStreet.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingContactAddressStreet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports